const STORAGE_KEY = "puckly-coach-practice-plan-v1";

export type PracticeStation = {
  drillId: string;
  title: string;
  durationMinutes: number;
  description: string;
  focus: string;
};

export type PracticePlan = {
  id: string;
  team: string;
  date: string;
  startTime: string;
  theme: string;
  equipment: string;
  stations: PracticeStation[];
  updatedAt: string;
};

export const emptyStation = (index: number): PracticeStation => ({
  drillId: "",
  title: `Station ${index + 1}`,
  durationMinutes: 15,
  description: "",
  focus: "",
});

export const emptyPlan = (): PracticePlan => ({
  id: "current-practice",
  team: "Puckly practice",
  date: new Date().toISOString().slice(0, 10),
  startTime: "",
  theme: "",
  equipment: "",
  stations: [emptyStation(0), emptyStation(1), emptyStation(2)],
  updatedAt: new Date().toISOString(),
});

export function normalizePlan(value: Partial<PracticePlan>): PracticePlan {
  const fallback = emptyPlan();
  return {
    ...fallback,
    ...value,
    id: value.id || fallback.id,
    stations: Array.from({ length: 3 }, (_, index) => ({
      ...emptyStation(index),
      ...value.stations?.[index],
    })),
    updatedAt:
      value.updatedAt && Number.isFinite(Date.parse(value.updatedAt))
        ? value.updatedAt
        : fallback.updatedAt,
  };
}

export function loadPlan(
  storage: Pick<Storage, "getItem"> = localStorage,
): PracticePlan {
  try {
    const saved = storage.getItem(STORAGE_KEY);
    return saved
      ? normalizePlan(JSON.parse(saved) as Partial<PracticePlan>)
      : emptyPlan();
  } catch {
    return emptyPlan();
  }
}

export function savePlan(
  plan: PracticePlan,
  storage: Pick<Storage, "setItem"> = localStorage,
) {
  const normalized = normalizePlan(plan);
  storage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}
